/** Catálogos del formulario de vehículos (una sola carga por sesión). */
let cached = null;
let inflight = null;

export async function fetchVehicleCatalog(getData) {
  if (cached) {
    return cached;
  }
  if (inflight) {
    return inflight;
  }

  inflight = Promise.all([
    getData('/brands', { skipLoader: true }),
    getData('/models', { skipLoader: true }),
    getData('/colors', { skipLoader: true }),
    getData('/fuelTypes', { skipLoader: true }),
    getData('/customers?page=1&limit=500', { skipLoader: true }),
  ])
    .then(([brandsRes, modelsRes, colorsRes, fuelRes, customersRes]) => {
      const models = [...(modelsRes?.payload?.models ?? [])].sort((a, b) =>
        String(a?.description || '').localeCompare(
          String(b?.description || ''),
          'es',
          { sensitivity: 'base' },
        ),
      );
      const colors = [...(colorsRes?.payload?.colors ?? [])].sort((a, b) =>
        String(a?.name || '').localeCompare(String(b?.name || ''), 'es', {
          sensitivity: 'base',
        }),
      );
      cached = {
        brands: brandsRes?.payload?.brands ?? [],
        models,
        colors,
        fuelTypes: fuelRes?.payload?.fuelTypes ?? [],
        customers: customersRes?.payload?.customers ?? [],
      };
      inflight = null;
      return cached;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
}

export function clearVehicleCatalogCache() {
  cached = null;
  inflight = null;
}
